import axios from 'axios';
import user from  '../utils/user';

export default {
  async getAll() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/routine-configs`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getRoutinesByProduct(policyTypeId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/routine-configs/${policyTypeId}/product-routines`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async save(payload) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_VIDA_URL}/routine-configs`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
